import CustomModal from "../../../common/components/modal/CustomDetailModal";
import { Divider, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import { TitleAndInput } from "../../../common/components/input/TitleAndInput";
import React, { useEffect, useState } from "react";
import DividerTextRow from "../../../common/components/text/DividerTextRow";
import { Theme } from "../../../common/Theme";
import FranchiseService from "../../../service/FranchiseService";
import LocalStorageKey from "../../../common/enums/LocalStorageKey";
import CustomPopup from "../../../common/components/popup/CustomPopup";

export default function FranchiseEditModal({ isOpen, onClose, onSave, dto }) {
    const service = new FranchiseService();
    // state
    const [name, setName] = useState(dto?.name || "");
    const [code, setCode] = useState(dto?.code || "");

    // button activated
    const [isButtonActivated, setIsButtonActivated] = useState(false);

    // popup
    const [isErrorPopup, setIsErrorPopup] = useState(false);
    const [errorContent, setErrorContent] = useState("프랜차이즈 코드는 영문 대문자 두자리만 허용합니다.");

    useEffect(() => {
        setIsButtonActivated(name.trim() !== "" && code.trim() !== "");
    }, [name, code]);

    const handleSave = async () => {
        const reqDto = {
            request: {
                idFranchise: dto?.idFranchise,
                countryCode: dto?.countryCode || localStorage.getItem(LocalStorageKey.server) || "TH",
                franchiseCode: code,
                name: name.trim(),
                timezone: dto?.timezone || "Asia/Seoul",
                maxTicketNo: dto?.maxTicketNo || 99,
            },
        };

        service
            .updateFranchise(reqDto)
            .then((result) => {
                console.log(result);
                if (result.resultCode === "9004") {
                    setErrorContent("이미 중복된 이름의 프랜차이즈가 존재합니다.");
                    setIsErrorPopup(true);
                } else if (result.resultCode === "0002") {
                    setErrorContent("프랜차이즈 코드 혹은 이름에 사용할 수 없는 문자가 포함되어 있습니다.");
                    setIsErrorPopup(true);
                } else {
                    if (onSave) onSave();
                    onClose();
                }
            })
            .catch((err) => {
                if (err.resultCode === "9004") {
                    setErrorContent("이미 중복된 이름의 프랜차이즈가 존재합니다.");
                    setIsErrorPopup(true);
                } else if (err.resultCode === "0002") {
                    setErrorContent("프랜차이즈 코드 혹은 이름에 사용할 수 없는 문자가 포함되어 있습니다.");
                    setIsErrorPopup(true);
                }
                console.error("Error updating franchise:", err);
            });
    };

    return (
        <CustomModal
            title={"Edit Franchise"}
            isOpen={isOpen}
            onClose={onClose}
            width={"552px"}
            side={"right"}
            height={"90vh"}
            bottomButtons={
                <Row justifyContent={"flex-end"} width={"100%"} padding={"22px 20px"}>
                    <SecondaryButton text={"Cancel"} width={"70px"} padding={"7.75px 14.5px"} onClick={onClose} />
                    <SizedBox width={"10px"} />
                    <PrimaryButton
                        text={"Save"}
                        width={"70px"}
                        padding={"7.75px 14.5px"}
                        onClick={handleSave}
                        disabled={!isButtonActivated}
                    />
                </Row>
            }
        >
            <DividerTextRow
                items={[
                    { label: "Registration", value: dto?.registeredDate },
                    { label: "registeredDate", value: dto?.updatedDate },
                ]}
            />
            <SizedBox height={"12px"} />
            <SizedBox
                border={`1px solid ${Theme.color.gray200}`}
                borderRadius={"16px"}
                width={"100%"}
                height={"auto"}
                padding={"20px"}
                alignItem={"flex-start"}
            >
                <TitleAndInput
                    title={"Franchise Code"}
                    type={"normal"}
                    placeholder={"Please enter the franchise code"}
                    inputValue={code}
                    setInputValue={setCode}
                    disabled={true}
                />
                <Divider marginTop={"11px"} marginBottom={"11px"} lineStyle={"custom-dotted"} />
                <TitleAndInput
                    title={"Franchise Name"}
                    type={"normal"}
                    placeholder={"Please enter the franchise name"}
                    inputValue={name}
                    setInputValue={setName}
                />
            </SizedBox>
            {/* TODO: 번역 확인 필요 */}
            <CustomPopup isOpen={isErrorPopup} onConfirm={() => setIsErrorPopup(false)} message={errorContent} />
        </CustomModal>
    );
}
